import "../../../../styles/page/dashboard.scss";

import AskMoveUnconfirmedLinesModal from "../../../common/components/AskMoveUnconfirmedLinesModal.jsx";
import CalendarCard from "../dashboard/CalendarCard.jsx";
import CampaignProductsCard from "./campaignProductsCard.jsx";
import ContentWrapper from "../../../common/components/ContentWrapper.jsx";
import CurrentTime from "../../../common/components/CurrentTime.jsx";
import DashboardHelpSupport from "../dashboard/dashboardHelpSupport.jsx";
import DashboardMyProductsList from "../dashboard/dashboardMyProductsList.jsx";
import DashboardTobbacoReturns from "../dashboard/DashboardTobbacoReturns.jsx";
import ImpersonateCard from "./impersonateCard";
import LastDeliveryCard from "../dashboard/lastDeliveryCard.jsx";
import {Localization} from "../../../common/util/localization.jsx";
import NewProductsCard from "../dashboard/newProductsCard.jsx";
import NextDeliveryCard from "../dashboard/nextDeliveryCard.jsx";
import PropTypes from "prop-types";
import React from "react";
import ResponsiveColumn from "../../../common/components/ResponsiveColumn.jsx";
import ResponsiveRows from "../../../common/components/ResponsiveRows.jsx";
import StopImpersonatingCard from "./stopImpersonatingCard";


class UserCard extends React.PureComponent {
    render(){
        const {
            localization,
            customer
        } = this.props;
        return (
            <div className="card-default user-card">
                <img src={customer.logoUrl} className={"nlogo"} />
                <div className={"welcome-text"} >
                    {localization.text("dashboard","welcome",{name:customer.customerName})}
                </div>
                <div className={"welcome-info"} >
                    {customer.streetAddress}
                </div>
            </div>
        );
    }
}
UserCard.propTypes = {
    localization: Localization.propTypes.isRequired,
    customer: PropTypes.object
};

class TimeCard extends React.Component {
    render(){
        return (
            <div className="card-default time-card">
                <div className="flex-container">
                    <CurrentTime/>
                </div>
            </div>
        );
    }
}
TimeCard.propTypes = {
};

class dashboardPage extends React.PureComponent {
    constructor(props){
        super(props);
        this.state = {
            inputText: "",
            selectedValue: null,
        };

        this.onChangeText = this.onChangeText.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);    
        this.onCloseModal = this.onCloseModal.bind(this);     
        this.onCloseModalAndCheck = this.onCloseModalAndCheck.bind(this);     
    }

    UNSAFE_componentWillMount() {
        const {
            activeOrder,
            botstrapDeliveryAndOrder,
            getCampaignProducts,
            getBoughtProducts,
            getNewProducts,
            getLastDelivery,
            getNextDelivery,
            getOrderFeeLimits,
            getOrderVolumeDiscounts,
        } = this.props;
        if( this.props.customer.customerId==null || this.props.customer.customerId===""){
            this.props.getCustomerInfo(this.props.signedInAs);
        }
        if( activeOrder && activeOrder.loading==false && activeOrder.shipmentId==null) {
            botstrapDeliveryAndOrder();
        }
        getCampaignProducts();
        getBoughtProducts();
        getNewProducts();
        getLastDelivery();
        getNextDelivery();
        getOrderFeeLimits();
        getOrderVolumeDiscounts();
    }

    componentDidUpdate(prevProps) {
        const {
            nextDelivery,
            setModal,
            localization,
            deliveryDates,
            moveUnconfirmedLinesToNextOrder,
            newSeasonDistrDates,
            displaySeasonLinesMessage,
            seasonMessageConfirmed,
        } = this.props;

        if (this.props.signedInAs && this.props.signedInAs !== prevProps.signedInAs) {
            this.props.getCustomerInfo(this.props.signedInAs);
        }

        if(newSeasonDistrDates.length > 0 && !seasonMessageConfirmed)
        {            
            displaySeasonLinesMessage(localization, this.onCloseModalAndCheck);
        }  
        else if (nextDelivery.oldUnconfirmedOrderLineCount && nextDelivery.oldUnconfirmedOrderLineCount  !== prevProps.nextDelivery.oldUnconfirmedOrderLineCount && nextDelivery.oldUnconfirmedOrderLineCount > 0 ) {
            setModal(<AskMoveUnconfirmedLinesModal  localization={localization} setModal={setModal} oldUnconfirmedOrderLineCount={nextDelivery.oldUnconfirmedOrderLineCount} deliveryDates={deliveryDates} orderLocked={false} moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder} onCloseModal={this.onCloseModal}/>);              
        }
    }    
    
    onCloseModalAndCheck() {
        const {
            nextDelivery,
            setModal,
            localization,
            deliveryDates,
            moveUnconfirmedLinesToNextOrder,
        } = this.props;

        this.props.setModal(null);

        if (nextDelivery.oldUnconfirmedOrderLineCount && nextDelivery.oldUnconfirmedOrderLineCount > 0 ) {
            setModal(<AskMoveUnconfirmedLinesModal  localization={localization} setModal={setModal} oldUnconfirmedOrderLineCount={nextDelivery.oldUnconfirmedOrderLineCount} deliveryDates={deliveryDates} orderLocked={false} moveUnconfirmedLinesToNextOrder={moveUnconfirmedLinesToNextOrder} onCloseModal={this.onCloseModal}/>);              
        }  
    }

    onCloseModal() {
        this.props.setModal(null);
    }

    onChangeText(change) {
        this.setState(change);
    }

    onChangeSelect(change) {
        this.setState(change);
    }

    render(){
        const {
            customer,
            deviceType,
            history,
            impersonateUser,
            isAdmin,
            isImpersonated,
            lastDelivery,
            lastDeliveryProductList,
            localization,
            nextDelivery,
            productLists,
            stopImpersonating,
            submitOrder,
            clearClaim,
            downloadHistoryPdf,
            signedInAs,
            token,
            setModal,
            orderFeeLimits,
            orderVolumeDiscounts,
            height,
            isBlockedCustomer,
            setDropDown,
            activeOrder,
            width,
            deliveryDates,
            setActiveOrder,
            newSeasonDistrDates,
        } = this.props;        

        return (
            <ContentWrapper>
                <ResponsiveRows gutters={false}>
                    <ResponsiveColumn xs={12} sm={8} md={8}>
                        <UserCard localization={localization} customer={customer}/>
                    </ResponsiveColumn>
                    {deviceType!=="xs" && (
                        <ResponsiveColumn sm={2} md={1}>
                            <TimeCard />
                        </ResponsiveColumn>                                 
                    )}
                    {deviceType!=="xs" && (
                           
                        <ResponsiveColumn sm={1} md={1}>
                            <CalendarCard deviceType={deviceType} activeOrder={activeOrder} width={width} setDropDown={setDropDown} localization={localization} deliveryDates={deliveryDates} setActiveOrder={setActiveOrder} history={history} newSeasonDistrDates = {newSeasonDistrDates}/>                              
                        </ResponsiveColumn>                                  
                    )}
                    {deviceType!=="xs" && (                           
                        <ResponsiveColumn sm={1} md={2}>
                        </ResponsiveColumn>                                  
                    )}
                </ResponsiveRows>
                <ResponsiveRows gutters={false}>
                    <ResponsiveColumn xs={12} md={8}>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12} sm={6}>
                                <NextDeliveryCard localization={localization} nextDelivery={nextDelivery} submitOrder={submitOrder} isBlockedCustomer={isBlockedCustomer} deviceType={deviceType}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={6}>
                                <LastDeliveryCard localization={localization} lastDelivery={lastDelivery} lastDeliveryProductList={lastDeliveryProductList} history={history} downloadHistoryPdf={downloadHistoryPdf} signedInAs={signedInAs} token={token} clearClaim={clearClaim} deviceType={deviceType} setModal={setModal} orderFeeLimits={orderFeeLimits} orderVolumeDiscounts={orderVolumeDiscounts} height={height}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={6}>
                                <CampaignProductsCard localization={localization} productLists={productLists} isBlockedCustomer={isBlockedCustomer}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={6}>
                                <NewProductsCard localization={localization} productLists={productLists} isBlockedCustomer={isBlockedCustomer}/>
                            </ResponsiveColumn>
                        </ResponsiveRows>
                    </ResponsiveColumn>
                    <ResponsiveColumn xs={12} md={4}>
                        <ResponsiveRows gutters={false}>
                            <ResponsiveColumn xs={12} sm={6} md={12}>
                                <DashboardMyProductsList localization={localization} isBlockedCustomer={isBlockedCustomer}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={6} md={12}>
                                <DashboardHelpSupport localization={localization}/>
                            </ResponsiveColumn>
                            <ResponsiveColumn xs={12} sm={6} md={12}>
                                <DashboardTobbacoReturns localization={localization}/>
                            </ResponsiveColumn>
                            {
                                isAdmin && <ResponsiveColumn xs={12} sm={6} md={12}><ImpersonateCard localization={localization} impersonateUser={impersonateUser} history={history}/></ResponsiveColumn>
                            }
                            {
                                isImpersonated && <ResponsiveColumn xs={12} sm={6} md={12}><StopImpersonatingCard localization={localization} stopImpersonating={stopImpersonating} history={history}/></ResponsiveColumn>
                            }
                        </ResponsiveRows>
                    </ResponsiveColumn>
                </ResponsiveRows>
            </ContentWrapper>
        );
    }
}

dashboardPage.propTypes = {
    activeOrder: PropTypes.object.isRequired,
    signedInAs: PropTypes.string.isRequired,
    deviceType: PropTypes.string.isRequired,
    getCustomerInfo: PropTypes.func.isRequired,
    getCampaignProducts: PropTypes.func.isRequired,
    getNewProducts: PropTypes.func.isRequired,
    getLastDelivery: PropTypes.func.isRequired,
    getNextDelivery: PropTypes.func.isRequired,
    localization: Localization.propTypes.isRequired,
    submitOrder: PropTypes.func.isRequired,
    botstrapDeliveryAndOrder: PropTypes.func.isRequired,
    getBoughtProducts: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool,
    isImpersonated: PropTypes.bool,
    impersonateUser: PropTypes.func.isRequired,
    stopImpersonating: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    clearClaim: PropTypes.func.isRequired,
    downloadHistoryPdf: PropTypes.func.isRequired,
    token: PropTypes.string.isRequired,
    customer: PropTypes.object,
    productLists: PropTypes.object,
    lastDelivery: PropTypes.object,
    lastDeliveryProductList: PropTypes.array,
    nextDelivery: PropTypes.object,
    nextDeliveryProductList: PropTypes.array,
    setModal: PropTypes.func.isRequired,
    getOrderFeeLimits: PropTypes.func.isRequired,
    orderFeeLimits: PropTypes.array.isRequired,
    getOrderVolumeDiscounts: PropTypes.func.isRequired,
    orderVolumeDiscounts: PropTypes.array.isRequired,
    height: PropTypes.number.isRequired,
    isBlockedCustomer : PropTypes.bool.isRequired,
    deliveryDates: PropTypes.array,
    setDropDown: PropTypes.func,
    width: PropTypes.number,
    setActiveOrder: PropTypes.func,
    newSeasonDistrDates : PropTypes.array.isRequired,
    moveUnconfirmedLinesToNextOrder: PropTypes.func.isRequired,
    displaySeasonLinesMessage: PropTypes.func.isRequired,
    seasonMessageConfirmed: PropTypes.bool.isRequired,
};

export default dashboardPage;